import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type ModeType = "last" | "predict" | "now";

interface IState {
  visible: boolean;
  time: any;
  mode: ModeType;
}

const initialState: IState = {
  visible: false,
  time: { to: "16:00:00", from: "15:00:00" },
  mode: "last",
};

export const passageSlice = createSlice({
  name: "passage",
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changeTime: (state, action: PayloadAction<any>) => {
      return { ...state, time: action.payload };
    },
    changeModeType: (state, action: PayloadAction<ModeType>) => {
      return { ...state, mode: action.payload };
    },
  },
});

export const { toggleVisibility, makeInvisible, changeTime, changeModeType } = passageSlice.actions;

export default passageSlice.reducer;
